import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, MessageCircle, Check } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { DICT } from "@/i18n/dict";
import { http, formatErr, waLink } from "@/lib/api";

const intl = (p) => (p.startsWith("0") ? "62" + p.slice(1) : p);

export default function CityWaitlist() {
  const { t } = useLang();
  const [groups, setGroups] = useState(null);
  useEffect(() => { http.get("/admin/city-waitlist").then((r) => setGroups(r.data)).catch(() => setGroups([])); }, []);
  const mark = async (e) => {
    try {
      await http.post(`/admin/city-waitlist/${e.id}/notified`);
      setGroups(groups.map((g) => ({ ...g, entries: g.entries.map((x) => (x.id === e.id ? { ...x, notified: true } : x)) })));
    } catch (err) { toast.error(formatErr(err)); }
  };
  const msg = (e, city) => `${(DICT[e.lang] || DICT.id).wl_wa_msg.replace("{name}", e.name || "").replace(" !", "!").replace("{city}", city)} ${window.location.origin}`;
  if (!groups) return null;
  return (
    <div data-testid="admin-city-waitlist" className="mt-10 rounded-3xl border border-slate-200 bg-white p-5">
      <h2 className="flex items-center gap-2 text-xl font-bold"><BellRing className="h-5 w-5 text-[#064E3B]" />{t("wl_admin_title")}</h2>
      {groups.length === 0 && <p data-testid="city-waitlist-empty" className="mt-3 text-sm text-slate-500">{t("wl_admin_empty")}</p>}
      <div className="mt-4 space-y-4">{groups.map((g) => (
        <div key={g.city} data-testid={`city-waitlist-group-${g.city}`}>
          <p className="text-sm font-bold text-slate-800">{g.name} · {g.entries.filter((e) => !e.notified).length}/{g.entries.length} {t("wl_waiting")}</p>
          <div className="mt-2 flex flex-wrap gap-2">{g.entries.map((e) => (
            e.notified
              ? <span key={e.id} data-testid={`city-waitlist-done-${e.id}`} className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-500"><Check className="h-3.5 w-3.5" />{e.name || e.phone}</span>
              : <a key={e.id} href={waLink(intl(e.phone), msg(e, g.name))} target="_blank" rel="noreferrer" onClick={() => mark(e)} data-testid={`city-waitlist-wa-${e.id}`} className="inline-flex items-center gap-1 rounded-full bg-[#25D366] px-3 py-1 text-xs font-bold text-white transition-transform hover:-translate-y-0.5"><MessageCircle className="h-3.5 w-3.5" />{e.name || e.phone}</a>
          ))}</div>
        </div>
      ))}</div>
    </div>
  );
}
